import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useImageDominantColor from '@cohort/wallet/hooks/useImageDominantColor';
import React from 'react';

interface VideoPlayerProps {
  imgUrl: string | null;
  videoFileKey: string;
  displayName: string;
  onImageLoad?: (imageDominantColor: string) => void;
  autoPlay?: boolean;
  className?: string;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  displayName,
  imgUrl,
  videoFileKey,
  onImageLoad: handleOnImageLoad,
  autoPlay,
  className,
}: VideoPlayerProps): React.ReactElement => {
  const imgRef = useImageDominantColor(handleOnImageLoad ?? (() => {}));

  return (
    <video
      controls
      className={classNames('overflow-clip rounded-xl', className)}
      autoPlay={autoPlay}
      playsInline
      webkit-playsinline="true"
      loop
      controlsList="nodownload"
      disablePictureInPicture
      poster={imgUrl ?? ''}
    >
      <source src={videoFileKey} />
      {imgUrl !== null && (
        <img
          ref={imgRef}
          title={displayName}
          src={imgUrl}
          className="w-full rounded-t-lg"
          crossOrigin="anonymous"
        />
      )}
    </video>
  );
};
VideoPlayer.displayName = 'VideoPlayer';
